// 全局样式对象 - CSS-in-JS 版本
export const globalStyles = {
  // 基础样式
  base: `
    html,
    body,
    #root {
      height: 100%;
      margin: 0;
      padding: 0;
      font-family:
        -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans',
        sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
    }

    /* 全局主题变量 */
    :root {
      --bg-color: #ffffff;
      --text-color: #000000;
      --border-color: #d9d9d9;
    }

    /* 暗色主题变量 */
    [data-theme="dark"],
    [data-theme="realDark"] {
      --bg-color: #141414;
      --text-color: #ffffff;
      --border-color: #424242;
    }

    /* 确保暗色主题下的背景色立即生效 */
    [data-theme="dark"] html,
    [data-theme="dark"] body,
    [data-theme="dark"] #root,
    [data-theme="realDark"] html,
    [data-theme="realDark"] body,
    [data-theme="realDark"] #root {
      background-color: var(--bg-color) !important;
      color: var(--text-color);
      transition: background-color 0.3s ease, color 0.3s ease;
    }

    /* 页面容器背景适配 */
    [data-theme="realDark"] .ant-pro-page-container,
    [data-theme="dark"] .ant-pro-page-container {
      background-color: var(--bg-color) !important;
    }

    /* Layout 组件背景适配 */
    [data-theme="realDark"] .ant-layout,
    [data-theme="dark"] .ant-layout {
      background-color: var(--bg-color) !important;
    }

    .colorWeak {
      filter: invert(80%);
    }

    .ant-layout {
      min-height: 100vh;
    }

    .ant-pro-sider.ant-layout-sider.ant-pro-sider-fixed {
      left: unset;
    }

    canvas {
      display: block;
    }

    body {
      text-rendering: optimizeLegibility;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    ul,
    ol {
      list-style: none;
    }

    @media (max-width: 768px) {
      .ant-table {
        width: 100%;
        overflow-x: auto;
      }
      
      .ant-table-thead > tr > th,
      .ant-table-tbody > tr > td {
        white-space: pre;
      }
      
      .ant-table-thead > tr > th > span,
      .ant-table-tbody > tr > td > span {
        display: block;
      }
    }
  `,
};

// 注入全局样式的函数
export const injectGlobalStyles = () => {
  const styleId = 'global-styles';

  // 如果已经存在，先移除
  const existingStyle = document.getElementById(styleId);
  if (existingStyle) {
    existingStyle.remove();
  }

  // 创建新的 style 元素
  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = globalStyles.base;

  // 插入到 head 中
  document.head.appendChild(style);
};
